import { render, staticRenderFns } from "./SilkPopup.vue?vue&type=template&id=2d4fae0a&"
import script from "./SilkPopup.vue?vue&type=script&lang=js&"
export * from "./SilkPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports